import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome, ${u.full_name}`);
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-5 bg-paper">
      <div className="lg:col-span-3 hidden lg:flex flex-col justify-between p-12 border-r border-rule bg-white">
        <div>
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-quiet">
            Internal Tool · Talent Acquisition
          </div>
          <div className="font-serif text-6xl xl:text-7xl leading-[0.95] tracking-tight mt-4 text-ink">
            Recruit—<br />Ops.
          </div>
          <p className="mt-6 text-quiet max-w-md">
            A control room for hiring. Raise requisitions, screen with AI, schedule interviews,
            collect feedback, and ship offers — without leaving the room.
          </p>
        </div>
        <div className="grid grid-cols-3 border-t border-rule pt-6 mt-12">
          <Stat n="01" l="Requisition" />
          <Stat n="02" l="AI Screen" />
          <Stat n="03" l="Hire" />
        </div>
      </div>

      <div className="lg:col-span-2 flex items-center justify-center p-8">
        <div className="w-full max-w-sm fade-up">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-quiet">
            Sign in
          </div>
          <h1 className="font-serif text-4xl mt-2 mb-8 text-ink">Welcome back.</h1>

          <form onSubmit={submit} className="space-y-5">
            <Field label="Email">
              <input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="hr@company.com"
                className="w-full bg-transparent border border-rule px-3 py-2.5 focus:outline-none focus:border-klein focus:ring-1 focus:ring-klein"
              />
            </Field>
            <Field label="Password">
              <input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-transparent border border-rule px-3 py-2.5 focus:outline-none focus:border-klein focus:ring-1 focus:ring-klein"
              />
            </Field>

            <button
              data-testid="login-submit"
              type="submit"
              disabled={busy}
              className="w-full bg-klein hover:bg-klein-hover text-white px-5 py-3 font-medium transition-colors disabled:opacity-50"
            >
              {busy ? "Signing in…" : "Sign in →"}
            </button>
          </form>

          <p className="text-xs text-quiet mt-6 font-mono uppercase tracking-wider">
            Internal tool · access by invitation only
          </p>
        </div>
      </div>
    </div>
  );
}

const Field = ({ label, children }) => (
  <label className="block">
    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-quiet">{label}</span>
    <div className="mt-1.5">{children}</div>
  </label>
);

const Stat = ({ n, l }) => (
  <div>
    <div className="font-mono text-xs text-quiet">{n}</div>
    <div className="font-serif text-xl text-ink mt-1">{l}</div>
  </div>
);
